// extracted by mini-css-extract-plugin
module.exports = {"input":"_1k0f7K","whiteButton":"_2NgeG2"};